import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconEye: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg height={$size} viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5091 4.44436C10.3422 5.30351 10.3422 6.69648 9.5091 7.55563C8.67598 8.41479 7.32524 8.41479 6.49213 7.55563C5.65902 6.69648 5.65902 5.30351 6.49213 4.44436C7.32524 3.5852 8.67598 3.5852 9.5091 4.44436Z"
        fill="#1E2846"
      />
      <path
        d="M15.8286 5.40188C14.9466 3.99525 13.8022 2.80038 12.5196 1.94616C11.1006 1.00016 9.53393 0.5 7.98928 0.5C6.57195 0.5 5.17829 0.917656 3.84697 1.74128C2.48931 2.58106 1.25932 3.80791 0.190997 5.38744C-0.0556665 5.75253 -0.064093 6.23511 0.169664 6.60913C1.04999 8.02984 2.18298 9.22644 3.44564 10.069C4.8673 11.0188 6.39729 11.5 7.98928 11.5C9.54626 11.5 11.1163 11.004 12.5292 10.0659C13.8112 9.21441 14.9532 8.01506 15.8319 6.59675C16.0572 6.23199 16.0559 5.76529 15.8286 5.40188ZM8.00061 9.3C6.23331 9.3 4.80063 7.82254 4.80063 6C4.80063 4.17746 6.23331 2.7 8.00061 2.7C9.76791 2.7 11.2006 4.17746 11.2006 6C11.1986 7.82168 9.76707 9.29792 8.00061 9.3Z"
        fill="#1E2846"
      />
    </svg>
  </IconStyled>
);

IconEye.defaultProps = iconDefaultProps;
IconEye.displayName = 'IconEye';

export default IconEye;
